import { baseUrl, httpClient } from '../providers/AppDataProvider';

export interface RelayDepositRecord {
  id: string;
  userEvmAddress?: string | null;
  userSolAddress?: string | null;
  userBtcAddress?: string | null;
  userTronAddress?: string | null;
  hyperliquidAddress?: string | null;
  depositAddr?: string | null;
  requestId?: string | null;
  solDepositAddr?: string | null;
  solRequestId?: string | null;
  btcDepositAddr?: string | null;
  btcRequestId?: string | null;
  tvmDepositAddr?: string | null;
  tvmRequestId?: string | null;
  loginTime?: string | null;
  createdAt?: string;
  updatedAt?: string;
}

export interface RelayDepositListResult {
  data: RelayDepositRecord[];
  total: number;
}

export interface RegenerateRelayDepositPayload {
  id: string;
  chainId: number;
}

export interface VerifyRelayDepositPayload {
  id?: string;
  chainId: number;
  depositAddress?: string;
  targetChainId?: number;
  currency?: string;
}

export interface RelayTriggeredCurrency {
  currency: string;
  symbol?: string | null;
  balance: string;
}

export interface VerifyRelayDepositResult {
  message: string;
  triggeredCurrencies: RelayTriggeredCurrency[];
  checkedCurrencies: number;
  failedCurrencies: number;
}

export async function listRelayDeposits(params: {
  page?: number;
  pageSize?: number;
  userEvmAddress?: string;
  userSolAddress?: string;
  depositAddress?: string;
}): Promise<RelayDepositListResult> {
  const query = new URLSearchParams();
  query.set('page', String(params.page ?? 1));
  query.set('pageSize', String(params.pageSize ?? 20));
  if (params.userEvmAddress) query.set('userEvmAddress', params.userEvmAddress);
  if (params.userSolAddress) query.set('userSolAddress', params.userSolAddress);
  if (params.depositAddress) query.set('depositAddress', params.depositAddress);

  const url = `${baseUrl}/relay/deposits?${query.toString()}`;
  const { json } = await httpClient(url, { method: 'GET' });
  return {
    data: json?.data ?? [],
    total: json?.total ?? 0,
  };
}

export async function regenerateRelayDeposit(
  payload: RegenerateRelayDepositPayload
): Promise<{ message: string; data: RelayDepositRecord }> {
  const url = `${baseUrl}/relay/deposits/regenerate`;
  const { json } = await httpClient(url, {
    method: 'POST',
    body: JSON.stringify(payload),
  });
  return json;
}

export async function verifyRelayDeposit(
  payload: VerifyRelayDepositPayload
): Promise<VerifyRelayDepositResult> {
  const url = `${baseUrl}/relay/deposits/verify`;
  const { json } = await httpClient(url, {
    method: 'POST',
    body: JSON.stringify(payload),
  });
  return json;
}

export const RELAY_DEPOSIT_CHAIN_OPTIONS = [
  { id: 8453, name: 'Base (EVM) — 8453' },
  { id: 792703809, name: 'Solana — 792703809' },
  { id: 728126428, name: 'Tron — 728126428' },
] as const;
